import React from 'react'
import './Homepage.css'
import sakiImg from './saki.jpeg'
import sakiImg2 from './saki2.jpeg'

const Homepage = () => {
  return (
    <>
    <section className="homepage-main">
      <img className="main-img" alt="image 1 of saki c" src={sakiImg} />
      <img className="main-img2" alt="image 2 of saki c" src={sakiImg2} />
      <div className='text-container'>
        <p className='main-text-heading'>WELCOME TO MY PORTFOLIO</p>
        <p className='main-text'>✨ My name is Saki ✨</p>
        <p className='main-text'><strong>I'm a Software Engineer, located in Denver, Colorado.</strong></p>
        <p className='main-text'>I specialize in creating full stack applications with an emphasis on simplistic, aesthetic design.</p>
        {/* <p className='status-text'>Currently open to work</p> */}
        <a href="https://docs.google.com/document/d/1HIAr-Uh6NMlFgmxK3VJnqqOZMppc2J9TV34BwQV4ajI/edit?usp=sharing"><button>Click Here for Resume</button></a>
      </div>
    </section>
    <section className='homepage-section'>
      <h2>Hello There!</h2>
      <p className='section-text-heading'>PLEASE HAVE A LOOK AROUND MY PORTFOLIO</p>
      <p className='section-text logo-text'>I created this portfolio using React <img src="https://user-images.githubusercontent.com/118419729/258551278-1d7ca95d-2590-4956-a70d-36493f0f5b57.png" alt="react logo" className='react-logo' /></p>
    </section>
    </>
  )
}

export default Homepage